import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import DataTable from '../../components/Table/DataTable';
import SearchBox from './../../components/SearchBox/SearchBox';
import DeleteTag from './../../components/DeleteTag/DeleteTag';

import { showAlert } from '../../store/ducks/alert';
import { getTags, getTagsBySearch, getTagsByOrder } from '../../services/tags';
import { CircularProgress } from '@material-ui/core';
import { Delete as DeleteIcon } from '@material-ui/icons';

const Tags = ({ location, match }) => {
  const dispatch = useDispatch();
  const [tags, setTags] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });
  const [isOrdering, setIsOrdering] = useState(0);
  const [orderDirections, setOrderDirections] = useState({
    item: 'email',
    direction: 'ASC',
  });
  const [open, setOpen] = useState(false);
  const [tagId, setTagId] = useState();
  const [slug, setSlug] = useState();


  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayTags();
  }, [isSearching, isOrdering, page]);

  useEffect(() => {
    document.addEventListener('keydown', escape, false);

    return () => {
      document.removeEventListener('keydown', escape, false);
    };
  }, []);

  const escape = useCallback(event => {
    if (event.keyCode === 27) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
      window.history.pushState({ searching: true }, 'Searching', '/' + window.location.href.split('/')[3]);
    }
  }, []);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const headers = ['id', 'name', 'slug'];

  const customActions = [
    {
      icon: <DeleteIcon />,
      action: item => {
        setTagId(item.id)
        setSlug(item.slug)
        handleDeleteTag();
      },
    },
  ];

  const handleDeleteTag = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const displayTags = async () => {
    try {
      setIsLoading(true);
      let tags;
      if (isSearching) {
        const { data } = await getTagsBySearch(searchField.searchItem, searchField.search);
        tags = data;
      } else if (isOrdering > 0) {
        const { data } = await getTagsByOrder(orderDirections.item, orderDirections.direction);
        tags = data;
      } else if (!isOrdering && !isSearching && Object.keys(match.params).length === 0) {
        const { data } = await getTags(page);
        tags = data;
      }
      if (!tags) return;

      setTags(tags.rows);
      setTotalItems(tags.count);
      setTotalPages(tags.pages);
      setPage(tags.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>Tags ({totalItems})</h1>

        <SearchBox
          selectItems={['slug', 'name']}
          onSubmitSearch={handleSubmitSearch}
          isSearching={isSearching}
          onKeyDown={escape}
          setIsOrdering={setIsOrdering}
        />
      </div>
      {open ? <DeleteTag onClose={handleClose} tagId={tagId} slug={slug} /> : ''}

      <DataTable
        useUid={false}
        head={headers}
        body={tags}
        action={true}
        isSlug
        customActions={customActions}
        bodyColumn={headers}
        linkPath={'tag'}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={setPage}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
      />
    </>
  );
};

export default Tags;
